<template>
  <div class="s_chat_middle_emoji_face">
    <span :class="'__KEFU__emoji-'+ text" @click.stop="emojiClick"></span>
  </div>
</template>
<script>
  export default {
    components:{},
    data() {
      return {
        
      }
    },
    props: [
      "text",
      "isInput"
      ],
    methods: {
      emojiClick() {
        this.$emit("emitEmojiClick", this.text);
      }
  },
  }
</script>

<style lang="scss">
.s_chat_middle_emoji_face {
  display: inline-block;
  @include faceItemMargin();
}
</style>